import { FilterMatchMode } from "primereact/api";

export class Parametro {
    model = {
        id: {
            value: null,
            export: false
        },
        nombre: {
            value: '',
            header: 'Nombre',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        codigo: {
            value: '',
            header: 'Código',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 4 caracteres',
            table: true,
            max: 100,
            min: 4,
        },
        valor: {
            value: '',
            header: 'Valor',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 1 caracteres',
            table: true,
            max: 100,
            min: 1,
        },
        empresa: {
            header: 'Empresa',
            value: null,
            required: 'Empresa es requerido',
            optionLabel: 'empresa',
            export: true,
            table: true
        },
    }
    optionLabel = 'nombre';
    strMsg = <><span style={{ fontStyle: 'italic', fontSize: '9px' }}><b>Código:</b><ul><li>2-F: Float con 2 decimales</li><li>1-I: Integer</li></ul></span></>
}
